import { ChangeDetectionStrategy, Component, inject, Input, OnInit, signal } from '@angular/core';
import { ICustomer } from '../../core/interfaces/ICustomer';
import { TranslatePipe } from '../../../../shared/pipes/trans.pipe';
import { LocaleDatetimeFormatPipe } from '../../../../shared/pipes/locale-datetime-format.pipe';
import { IActionHistoryRecord } from '../../core/interfaces/IActionHistoryRecord';
import { CustomersService } from '../../core/services/CustomersService';
import { finalize } from 'rxjs';
import { ApiErrorResponse } from '../../../../core/classes/ApiErrorResponse';
import { NotificationService } from '../../../../core/services/NotificationService';
import { LoaderComponent } from '../../../../shared/components/loader/loader.component';
import { BaseComponent } from '../../../../core/layout/components/abstracts/base.component';

@Component({
  selector: 'app-actions-history-table',
  standalone: true,
  imports: [
    TranslatePipe,
    LocaleDatetimeFormatPipe,
    LoaderComponent
  ],
  templateUrl: './actions-history-table.component.html',
  styleUrl: './actions-history-table.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ActionsHistoryTableComponent extends BaseComponent implements OnInit {

  @Input({ required: true }) customer: ICustomer;

  public isLoading = signal(true);
  public data: IActionHistoryRecord[] = [];

  private readonly _customersService = inject(CustomersService);
  private readonly _notificationService = inject(NotificationService);

  public ngOnInit(): void {
    this._customersService.getCustomerActions(this.customer)
      .pipe(
        finalize(() => this.isLoading.set(false))
      )
      .subscribe({
        next: (data) => this.data = data.data,
        error: ({ error }: ApiErrorResponse) => {
          this._notificationService.pushError(
            'Fehler'.trans('notifications/error.Title'),
            error.message.trans(`get-customer-actions/notifications/${error.message}.Message`)
          );
        }
      });
  }
}
